import { render, staticRenderFns } from "./UploadLuaFiles.vue?vue&type=template&id=2bacb1da&"
import script from "./UploadLuaFiles.vue?vue&type=script&lang=ts&"
export * from "./UploadLuaFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports